import api from '../../utils/api'
import apiSubmissionError from '../../utils/apiSubmissionError'

export const createAccountApi = (data) => api.post('/managers/users', data).catch(apiSubmissionError)
export const updateUserInfoApi = (id, data) => api.put(`/managers/users/${id}`, data).catch(apiSubmissionError)
export const updateSuperAdminInfoApi = (id, data) => api.put(`/admins/users/${id}`, data).catch(apiSubmissionError)
export const updateUserPasswordApi = (data) => api.put('/passwords/change', data).catch(apiSubmissionError)
